// Affiliate/commission disclosure intentionally not displayed. Component kept as a no-op
// so existing imports across pages continue to work without edits.
export const AffiliateDisclosure = () => null;
